/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-lonely-if */
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Container, Grid, Box, useMediaQuery, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import { useApolloClient } from '@apollo/client';
import BroadbandPrequalInput from './BroadbandPrequalInput';
import BroadbandBeforePrequalTitle from './BroadbandBeforePrequalTitle';
import BroadbandAfterPrequalTitle from './BroadbandAfterPrequalTitle';
import BroadbandPrequalResult from './BroadbandPrequalResult';
import EirCustomerCheckModal from '../eir-customer-check/EirCustomerCheckModal';
import EirExisitingCustomerModal from '../eir-customer-check/EirExisitingCustomerModal';
import {
  getPrequal,
  formatAddress,
  checkService,
  createAddressObject,
  getEligibleServicesWithFutureAvailability,
} from './Broadband.util';
import useLocalStorage, { setCode } from '../../hooks/useLocalStorage';
import styles from './styles';
import { useToggle } from '../../hooks/useToggle';
import EirLoader from '../eir-loader/EirLoader';
import BroadbandPrequalAdvertisement from './BroadbandPrequalAdvertisement';
import BroadbandPrequalPhoneInput from './BroadbandPrequalPhoneInput';
import { getTokenFromCookies, setCookie } from '../../hooks/useCookie';
import DataMismatchModal from './DataMismatchModal';
import {
  PREQUAL_FAILED_TITLE,
  PREQUAL_FAILED_DESCRIPTION_PRE,
  PREQUAL_FAILED_DESCRIPTION_POST,
} from '../shared/Constants';
import { preventNBICheck } from './NBI.util';
import DataRetrievalModal from './DataRetrievalModal';
import PrequalNotRespondingModal from './PrequalNotRespondingModal';
import ErrorModal from '../eir-error-modal/ErrorModal';
import ApiFailureModal from '../eir-error-modal/ApiFailureModal';
import UANErrorModal from '../eir-ascertain-service/UANErrorModal';

const { publicRuntimeConfig } = getConfig();

const BroadbandPrequalBanner = props => {
  const theme = useTheme();
  const localStore = useLocalStorage();
  const Graphql = useApolloClient();
  const router = useRouter();
  const { setLocalStorage, hasValue, removeLocalStorage, getLocalStorage } = localStore;
  // const [isPrequaled, setIsPrequaled] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  // const [prequalByPhone, setPrequalByPhone] = useState(false);
  const [prequalFailed, setPrequalFailed] = useState(false);
  const [prequalEircode, setPrequalEircode] = useState('');
  const [prequalAddress, setPrequalAddress] = useState({});
  const [phoneNumber, setPhoneNumber] = useState({});
  const [acquisitionType, setAcquisitionType] = useState('');
  const [isNBI, setIsNBI] = useState(false);
  const [isNBIMultiline, setNBIMultiline] = useState(false);
  const [existingR6Customer, setExistingR6Customer] = useState(false);
  const [setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [neqCounter, setNeqCounter] = useState(0);
  const errorModalMaxOccurence = 1;
  const [onLoadError, setOnLoadError] = useState(false);
  const errorUANModal = useToggle(false);

  // const [FTTHinFuture, setFTTHinFuture] = useState(false);
  const dataMismatchModal = useToggle(false);
  const dataRetrievalModal = useToggle(false);
  const prequalNotRespondingModal = useToggle(false);
  const errorBBModal = useToggle(false);
  const openAPIFailureModal = useToggle(false);
  const openAccountCheck = useToggle(false);
  const existingCustomerModal = useToggle(false);

  const handleOk = () => {
    dataRetrievalModal.disable();
    openAPIFailureModal.disable();
  };
  const sm = useMediaQuery(theme.breakpoints.down('md'));
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const extraLarge = useMediaQuery(theme.breakpoints.up(1750));

  /**
   * @name isR6FlowCheck - to check R6 flow by prequal services
   */
  // function isR6FlowCheck(services) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       const BB_SERVICES = [
  //         { id: 'FTTH', r6: false },
  //         { id: 'NBI', r6: true },
  //         { id: 'FTTC', r6: false },
  //         { id: 'NGB', r6: true },
  //         { id: 'DSL', r6: true },
  //       ];
  //       let result = false;
  //       if (services.length === 0) {
  //         result = true;
  //       } else {
  //         const techs = BB_SERVICES.map(service => service.id);
  //         // Sorting services based on the order of BB_SERVICES
  //         const sortedService = services.sort((a, b) => techs.indexOf(a) - techs.indexOf(b));
  //         result = BB_SERVICES.filter(
  //           service => service.id === sortedService[0]?.broadbandTechnology
  //         )[0]?.r6;
  //       }
  //       resolve(result);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  /**
   * @name prequalHandler - Handle Check Availability button from BroadbandPrequalInput
   */

  useEffect(() => {
    if (props.isNBIJourney) {
      props.setLoading(true);
      setIsNBI(true);
    }
  }, [props.isNBIJourney]);

  useEffect(() => {
    if (props.currentService !== 'NBI' && props.currentService !== '') {
      setShowLoader(false);
      props.setIsPrequaled(true);
      props.setPrequalStatus(true);
    }
  }, [props.currentService]);

  useEffect(() => {
    if (isNBI && !isNBIMultiline) {
      preventNBICheck(
        Graphql,
        props.NEQDetails,
        props.setEnableModal,
        props.setLoading,
        props.enableNBIPrevention,
        props.setNEQDetails,
        setNBIMultiline,
        errorBBModal,
        errorModalOccurence,
        dataRetrievalModal,
        setErrorModalOccurence,
        setOnLoadError,
        openAPIFailureModal,
        router.asPath
      );
    }
  }, [props.NEQDetails]);

  const newAcquisitionHandler = async res => {
    // setCode('ACQ');
    if (!props.prequalByPhone) {
      if (res?.services?.length === 0) {
        setPrequalFailed(true);
        props.setPrequalByPhone(true);
        setShowLoader(false);
      } else {
        // setShowLoader(true);
        // props.setIsPrequaled(true);
        props.setPrequalStatus(true);
        // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
        props.setErrorModalOccurence(0);
        // If customer is NEW
        if (res.customerType === 'NEW') {
          // set result to localstorage
          setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));

          // Check for services that R6 will handle, with the first service in services list
          // const isR6Flow = await isR6FlowCheck(res.services);
          // if (isR6Flow) {
          //   window.location.href = `${origin}/broadband/results`;
          // } else {
          const addressData = res.addressResponse;
          res.fullAddress = formatAddress(addressData);
          res.eircode = addressData?.eirCode;
          setLocalStorage('PROSPECTUUID', res.reference);
          setCookie('ACQ', 'reference', res.reference);
          setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
          setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
          checkService(
            Graphql,
            res.services,
            false,
            props.setMaxSpeed,
            props.setIsMBBJourney,
            props.setIsNBIJourney,
            props.setLoading,
            props.setCurrentService,
            props.setFTTHinFuture,
            props.setShowPrequalTopTag,
            props.setFutureDate,
            props.setFutureSpeed,
            props.setNEQDetails,
            errorBBModal,
            errorModalOccurence,
            errorModalMaxOccurence,
            neqCounter,
            setNeqCounter,
            dataRetrievalModal,
            setErrorModalOccurence,
            setOnLoadError,
            openAPIFailureModal,
            props.setIsPrequaled,
            setShowLoader,
            props.setprequalCTALoaderText,
            router.asPath
          );
          if (!getTokenFromCookies()) openAccountCheck.enable();
          // setShowLoader(false);
          // props.setIsPrequaled(true);
          // }
        } else {
          if (res?.billingSource) {
            if (res.billingSource === 'R6') {
              const addressData = res.addressResponse;
              res.fullAddress = formatAddress(addressData);
              res.eircode = addressData?.eirCode;
              setLocalStorage('PROSPECTUUID', res.reference);
              setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
              const services = getEligibleServicesWithFutureAvailability(res.services);
              const isServiceExist = service =>
                services.find(item => item[service] === true) || null;
              const r6NGB = isServiceExist('NGB');
              if (r6NGB && res.customerType === 'NGB') {
                props.setMaxSpeed(r6NGB.speed);
                props.setIsR6NGB(true);
              } else if (res.customerType !== 'NGB') {
                errorUANModal.enable();
                props.setIsPrequaled(false);
                props.setPrequalStatus(false);
                setExistingR6Customer(true);
              } else {
                openAPIFailureModal.enable();
                props.setIsPrequaled(false);
                props.setPrequalStatus(false);
                setExistingR6Customer(true);
              }
            } else if (res.billingSource === 'ION') {
              props.setPrequaledFromBanner(true);
              props.setEnableModal(true);
            }
          } else {
            props.setPrequaledFromBanner(true);
            props.setEnableModal(true);
          }
        }
      }
    } else {
      // the phone flow
      if (res?.services?.length === 0) {
        // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/broadband`);
        // window.location.href = `${origin}/shop/mobile/broadband/`;
      } else {
        // eslint-disable-next-line no-constant-condition
        setShowLoader(false);
        props.setIsPrequaled(true);
        props.setPrequalStatus(true);

        // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
        props.setErrorModalOccurence(0);
        // If customer is NEW
        if (res.customerType === 'NEW') {
          // set result to localstorage
          // setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));

          // Check for services that R6 will handle, with the first service in services list
          // const isR6Flow = await isR6FlowCheck(res.services);
          // if (isR6Flow) {
          //   window.location.href = `${origin}/broadband/results`;
          // } else {
          const addressData = res.addressResponse;
          res.fullAddress = formatAddress(addressData);
          res.eircode = addressData?.eirCode;
          setLocalStorage('PROSPECTUUID', res.reference);
          setCookie('ACQ', 'reference', res.reference);
          setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
          setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
          checkService(
            Graphql,
            res.services,
            false,
            props.setMaxSpeed,
            props.setIsMBBJourney,
            props.setIsNBIJourney,
            props.setLoading,
            props.setCurrentService,
            props.setFTTHinFuture,
            props.setShowPrequalTopTag,
            props.setFutureDate,
            props.setFutureSpeed,
            props.setNEQDetails,
            errorBBModal,
            errorModalOccurence,
            errorModalMaxOccurence,
            neqCounter,
            setNeqCounter,
            dataRetrievalModal,
            setErrorModalOccurence,
            setOnLoadError,
            openAPIFailureModal,
            props.setIsPrequaled,
            setShowLoader,
            props.setprequalCTALoaderText,
            router.asPath
          );
          if (!getTokenFromCookies()) openAccountCheck.enable();
          setShowLoader(false);
          props.setIsPrequaled(true);
          props.setPrequalStatus(true);
          // }
        } else {
          if (res?.billingSource) {
            if (res.billingSource === 'R6') {
              const addressData = res.addressResponse;
              res.fullAddress = formatAddress(addressData);
              res.eircode = addressData?.eirCode;
              setLocalStorage('PROSPECTUUID', res.reference);
              setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
              const services = getEligibleServicesWithFutureAvailability(res.services);
              const isServiceExist = service =>
                services.find(item => item[service] === true) || null;
              const r6NGB = isServiceExist('NGB');
              if (r6NGB && res.customerType === 'NGB') {
                props.setMaxSpeed(r6NGB.speed);
                props.setIsR6NGB(true);
              } else if (res.customerType !== 'NGB') {
                errorUANModal.enable();
                props.setIsPrequaled(false);
                props.setPrequalStatus(false);
                setExistingR6Customer(true);
              } else {
                openAPIFailureModal.enable();
                props.setIsPrequaled(false);
                props.setPrequalStatus(false);
                setExistingR6Customer(true);
              }
              // window.location.href = `${origin}/broadband/`;
            } else if (res.billingSource === 'ION') {
              props.setPrequaledFromBanner(true);
              props.setEnableModal(true);
            }
          } else {
            props.setPrequaledFromBanner(true);
            props.setEnableModal(true);
          }
        }
      }
    }
  };
  const crossSellAcquisitionHandler = async res => {
    setCode('CS');
    if (!props.prequalByPhone) {
      if (res?.services?.length === 0) {
        setPrequalFailed(true);
        props.setPrequalByPhone(true);
        setShowLoader(false);
      } else {
        setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
        const addressData = res.addressResponse;
        res.fullAddress = formatAddress(addressData);
        res.eircode = addressData?.eirCode;
        setLocalStorage('PROSPECTUUID', res.reference);
        setLocalStorage('PREQUAL_RESULT', JSON.stringify(res));
        checkService(
          Graphql,
          res.services,
          true,
          props.setMaxSpeed,
          props.setIsMBBJourney,
          props.setIsNBIJourney,
          props.setLoading,
          props.setCurrentService,
          props.setFTTHinFuture,
          props.setShowPrequalTopTag,
          props.setFutureDate,
          props.setFutureSpeed,
          props.setNEQDetails,
          errorBBModal,
          errorModalOccurence,
          errorModalMaxOccurence,
          neqCounter,
          setNeqCounter,
          dataRetrievalModal,
          setErrorModalOccurence,
          setOnLoadError,
          openAPIFailureModal,
          props.setIsPrequaled,
          setShowLoader,
          props.setprequalCTALoaderText,
          router.asPath
        );
        setShowLoader(false);
        props.setIsPrequaled(true);
        props.setPrequalStatus(true);
        // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
        props.setErrorModalOccurence(0);
        // second half of flow
      }
    } else {
      // the phone flow
      if (res?.services?.length === 0) {
        // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/broadband`);
        // window.location.href = `${origin}/shop/mobile/broadband/`;
      } else {
        setShowLoader(false);
        props.setIsPrequaled(true);
        props.setPrequalStatus(true);
        checkService(
          Graphql,
          res.services,
          true,
          props.setMaxSpeed,
          props.setIsMBBJourney,
          props.setIsNBIJourney,
          props.setLoading,
          props.setCurrentService,
          props.setFTTHinFuture,
          props.setShowPrequalTopTag,
          props.setFutureDate,
          props.setFutureSpeed,
          props.setNEQDetails,
          errorBBModal,
          errorModalOccurence,
          errorModalMaxOccurence,
          neqCounter,
          setNeqCounter,
          dataRetrievalModal,
          setErrorModalOccurence,
          setOnLoadError,
          openAPIFailureModal,
          props.setIsPrequaled,
          setShowLoader,
          props.setprequalCTALoaderText,
          router.asPath
        );
        // eslint-disable-next-line no-constant-condition
        // second half of flow
      }
    }
  };
  /**
   * @name prequalHandler - Handle Check Availability button from BroadbandPrequalInput
   */
  const prequalHandler = async (graphql, address = prequalAddress) => {
    setPrequalAddress(address);
    setPrequalEircode(address?.eircode);
    setShowLoader(true);
    props.setprequalCTALoaderText('Checking availability');
    let acqType = '';
    if (getTokenFromCookies().length !== 0) {
      setAcquisitionType('CROSS_SELL');
      acqType = 'CROSS_SELL';
    }
    try {
      const { res, result } = await getPrequal(graphql, address, undefined, acqType);
      if (res) {
        if (acquisitionType === '') newAcquisitionHandler(res);
        else if (acquisitionType === 'CROSS_SELL') crossSellAcquisitionHandler(res);
      } else if (result) {
        localStorage.setItem(
          JSON.stringify('ACQ_PREQUAL_RESULT'),
          JSON.stringify(result?.extensions?.onlinePrequalId)
        );
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband`);
        setShowLoader(false);
        setOnLoadError(true);
        setOpenError(true);
        setErrorModalOccurence(errorModalOccurence + 1);
        errorBBModal.enable();
        setCookie('ION', 'API_FAILED', 'getPrequal');
        prequalNotRespondingModal.enable();
        // window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}/broadband`;
      }
    } catch (err) {
      setShowLoader(false);
      setOnLoadError(true);
      props.setIsPrequaled(false);
      props.setPrequalStatus(false);
      setErrorModalOccurence(errorModalOccurence + 1);
      errorBBModal.enable();
      setCookie('ION', 'API_FAILED', 'getPrequal');
      prequalNotRespondingModal.enable();
    }
  };
  /**
   * @name prequalByPhoneHandler - Handle Check Availability button from BroadbandPrequalByPhoneInput
   */
  const prequalByPhoneHandler = async (graphql, phone, address = prequalAddress) => {
    try {
      setShowLoader(true);
      props.setprequalCTALoaderText('Checking availability');
      setPhoneNumber(phone);
      const { res, result } = await getPrequal(
        graphql,
        address,
        {
          areaCode: phone.areaCode,
          teleNumber: phone.phoneNumber.toString(),
        },
        acquisitionType
      );
      if (res) {
        if (acquisitionType === '') newAcquisitionHandler(res);
        else if (acquisitionType === 'CROSS_SELL') crossSellAcquisitionHandler(res);
      } else if (result) {
        setLocalStorage('PREQUAL_RESULT', JSON.stringify(result?.extensions?.onlinePrequalId));
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband`);
        // window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}/broadband`;
      }
    } catch (err) {
      if (err?.message.includes('Prequal data mismatch')) {
        setShowLoader(false);
        props.setIsPrequaled(false);
        props.setPrequalStatus(false);
        dataMismatchModal.enable();
        return;
      }
      setShowLoader(false);
      props.setIsPrequaled(false);
      props.setPrequalStatus(false);
      props.setErrorModalOccurence(props.errorModalOccurence + 1);
    }
  };
  /**
   * @name changeAddress - Remove the prequal result and get back to eircode input form
   */
  // const changeAddress = () => {
  //   removeLocalStorage('PREQUAL_RESULT');
  //   setIsPrequaled(false);
  //   props.setPrequalStatus(false);
  //   props.setErrorModalOccurence(0);
  //   setPrequalByPhone(false);
  // };
  const changePhoneNumber = () => {
    props.setIsMBBJourney(false);
    props.setIsR6NGB(false);
    removeLocalStorage('PREQUAL_RESULT');
    props.setIsPrequaled(false);
    props.setPrequalStatus(false);
    props.setErrorModalOccurence(0);
    props.setPrequalByPhone(true);
    setPrequalFailed(false);
    props.setFTTHinFuture(false);
    props.setShowPrequalTopTag(false);
  };

  useEffect(() => {
    if (props.changeOffer) {
      setCode('CO');
      props.setIsPrequaled(true);
      props.setPrequalStatus(true);
      checkService(
        Graphql,
        JSON.parse(getLocalStorage('PREQUAL_RESULT'))?.services,
        true,
        props.setMaxSpeed,
        props.setIsMBBJourney,
        props.setIsNBIJourney,
        props.setLoading,
        props.setCurrentService,
        props.setFTTHinFuture,
        props.setShowPrequalTopTag,
        props.setFutureDate,
        props.setFutureSpeed,
        props.setNEQDetails,
        errorBBModal,
        errorModalOccurence,
        errorModalMaxOccurence,
        neqCounter,
        setNeqCounter,
        dataRetrievalModal,
        setErrorModalOccurence,
        setOnLoadError,
        openAPIFailureModal,
        props.setIsPrequaled,
        setShowLoader,
        props.setprequalCTALoaderText,
        router.asPath
      );
    } else {
      if (hasValue('PREQUAL_RESULT') && hasValue('PROSPECTUUID')) {
        props.setIsPrequaled(true);
        props.setPrequalStatus(true);
        checkService(
          Graphql,
          JSON.parse(getLocalStorage('PREQUAL_RESULT'))?.services,
          false,
          props.setMaxSpeed,
          props.setIsMBBJourney,
          props.setIsNBIJourney,
          props.setLoading,
          props.setCurrentService,
          props.setFTTHinFuture,
          props.setShowPrequalTopTag,
          props.setFutureDate,
          props.setFutureSpeed,
          props.setNEQDetails,
          errorBBModal,
          errorModalOccurence,
          errorModalMaxOccurence,
          neqCounter,
          setNeqCounter,
          dataRetrievalModal,
          setErrorModalOccurence,
          setOnLoadError,
          openAPIFailureModal,
          props.setIsPrequaled,
          setShowLoader,
          props.setprequalCTALoaderText,
          router.asPath
        );
      } else {
        props.setIsPrequaled(false);
        props.setPrequalStatus(false);
      }
    }
  }, [props.changeOffer]);

  useEffect(() => {
    const address = localStorage.getItem('R6_PREQUAL_ADDRESS');
    if (address) {
      let rcvdAddress = JSON.parse(address);
      rcvdAddress = createAddressObject(rcvdAddress, rcvdAddress.eircode);
      prequalHandler(Graphql, rcvdAddress);
    }
    // setCode('');
  }, []);

  const redirectToWebchat = () => {
    existingCustomerModal.disable();
  };
  return (
    <Container style={{ maxWidth: 'unset', paddingLeft: '0px', paddingRight: '0px' }}>
      <Grid
        container
        sx={
          props.isPrequaled || props.COEligibilityStatus === 'ECC' || props.holdPrequal
            ? styles(theme).afterPrequalBanner
            : styles(theme).prequalBannerContainer
        }
      >
        {props.holdPrequal ? (
          <Grid
            item
            xs={12}
            md={!props.isPrequaled ? 12 : 6}
            sx={!props.isPrequaled ? styles(theme).afterprequalBox : styles(theme).prequalBox}
          >
            <BroadbandAfterPrequalTitle
              titleAfterPrequalFirstHalf={props.cmsData?.titleAfterPrequalFirstHalf}
              titleAfterPrequalSecondHalf={props.cmsData?.titleAfterPrequalSecondHalf}
              r6NGBTitleAfterPrequalFirstHalf={props.cmsData?.r6NGBTitleAfterPrequalFirstHalf}
              r6NGBTitleAfterPrequalSecondHalf={props.cmsData?.r6NGBTitleAfterPrequalSecondHalf}
              MBBTitleAfterPrequal={props.cmsData?.MBBTitleAfterPrequal}
              FTTHinFuture={props.FTTHinFuture}
              fontColor={props.cmsData?.titleAfterPrequalColor}
              COEligibilityStatus={props.COEligibilityStatus}
              maxSpeed={props.maxSpeed}
              isR6NGB={props.isR6NGB}
              isNBIJourney={props.isNBIJourney}
              isMBBJourney={props.isMBBJourney}
              holdPrequal={props.holdPrequal}
            />
          </Grid>
        ) : (
          <>
            {props.COEligibilityStatus === 'ECC' && !props.isPrequaled ? (
              <Grid
                item
                xs={12}
                md={!props.isPrequaled ? 12 : 6}
                sx={!props.isPrequaled ? styles(theme).afterprequalBox : styles(theme).prequalBox}
              >
                <Box
                  sx={{
                    ...styles(theme).prequalTitleContainer,
                    alignItems:
                      !props.isPrequaled &&
                      props.cmsData?.PrequalContentAlign === 'Center' &&
                      md &&
                      'center',
                    textAlign:
                      !props.isPrequaled &&
                      props.cmsData?.PrequalContentAlign === 'Center' &&
                      md &&
                      'center',
                  }}
                >
                  {props.COEligibilityStatus !== 'ECC' ? (
                    <BroadbandBeforePrequalTitle
                      title={props.cmsData?.titleBeforePrequal}
                      subTitle={props.cmsData?.subTitleBeforePrequal}
                      fontColor={props.cmsData?.titleBeforePrequalColor}
                      subTitleFontColor={props.cmsData?.subTitleBeforePrequalColor}
                      sm={sm}
                      ShowOfferImage={props.cmsData?.ShowOfferImage}
                    />
                  ) : (
                    <Box sx={{ paddingInline: { xs: '0rem', md: '6rem' } }}>
                      <BroadbandAfterPrequalTitle
                        titleAfterPrequalFirstHalf={props.cmsData?.titleAfterPrequalFirstHalf}
                        titleAfterPrequalSecondHalf={props.cmsData?.titleAfterPrequalSecondHalf}
                        r6NGBTitleAfterPrequalFirstHalf={
                          props.cmsData?.r6NGBTitleAfterPrequalFirstHalf
                        }
                        r6NGBTitleAfterPrequalSecondHalf={
                          props.cmsData?.r6NGBTitleAfterPrequalSecondHalf
                        }
                        MBBTitleAfterPrequal={props.cmsData?.MBBTitleAfterPrequal}
                        FTTHinFuture={props.FTTHinFuture}
                        fontColor={props.cmsData?.titleAfterPrequalColor}
                        COEligibilityStatus={props.COEligibilityStatus}
                        maxSpeed={props.maxSpeed}
                        isR6NGB={props.isR6NGB}
                        isMBBJourney={props.isMBBJourney}
                        isNBIJourney={props.isNBIJourney}
                      />
                      <BroadbandPrequalResult
                        // changeAddress={changeAddress}
                        changePhoneNumber={changePhoneNumber}
                        setIsPrequaled={props.setIsPrequaled}
                        setPrequalStatus={props.setPrequalStatus}
                        fontColor={props.cmsData?.titleAfterPrequalColor}
                        setErrorModalOccurence={props.setErrorModalOccurence}
                        prequalByPhone={props.prequalByPhone}
                        phoneNumber={phoneNumber}
                        setPrequalByPhone={props.setPrequalByPhone}
                        changeOffer={props.changeOffer}
                        COEligibilityStatus={props.COEligibilityStatus}
                        key={props.COEligibilityStatus}
                        setIsMBBJourney={props.setIsMBBJourney}
                        setIsR6NGB={props.setIsR6NGB}
                        setFTTHinFuture={props.setFTTHinFuture}
                        setShowPrequalTopTag={props.setShowPrequalTopTag}
                        openAccountCheck={openAccountCheck}
                        setIsNBIJourney={props.setIsNBIJourney}
                        setNBIMultiline={setNBIMultiline}
                        setCurrentService={props?.setCurrentService}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            ) : (
              <>
                {md && <Grid item md={0.1} lg={0.5} xl={0.5} />}
                <Grid
                  item
                  xs={12}
                  md={props.isPrequaled || props.cmsData?.PrequalContentAlign === 'Center' ? 12 : 6}
                  lg={
                    props.isPrequaled || props.cmsData?.PrequalContentAlign === 'Center' ? 12 : 5.5
                  }
                  xl={props.isPrequaled || props.cmsData?.PrequalContentAlign === 'Center' ? 12 : 5}
                  sx={props.isPrequaled ? styles(theme).afterprequalBox : styles(theme).prequalBox}
                >
                  <Box
                    sx={{
                      ...styles(theme).prequalTitleContainer,
                      alignItems:
                        !props.isPrequaled &&
                        props.cmsData?.PrequalContentAlign === 'Center' &&
                        md &&
                        'center',
                      textAlign:
                        !props.isPrequaled &&
                        props.cmsData?.PrequalContentAlign === 'Center' &&
                        md &&
                        'center',
                    }}
                  >
                    {/* eslint-disable-next-line no-nested-ternary */}
                    {!props.isPrequaled ? (
                      <BroadbandBeforePrequalTitle
                        title={
                          !prequalFailed ? props.cmsData?.titleBeforePrequal : PREQUAL_FAILED_TITLE
                        }
                        subTitle={
                          !prequalFailed
                            ? props.cmsData?.subTitleBeforePrequal
                            : `${PREQUAL_FAILED_DESCRIPTION_PRE}<strong>${prequalEircode}</strong>${PREQUAL_FAILED_DESCRIPTION_POST}`
                        }
                        fontColor={props.cmsData?.titleBeforePrequalColor}
                        subTitleFontColor={props.cmsData?.subTitleBeforePrequalColor}
                        ShowOfferImage={props.cmsData?.ShowOfferImage}
                        sm={sm}
                      />
                    ) : (
                      <BroadbandAfterPrequalTitle
                        titleAfterPrequalFirstHalf={props.cmsData?.titleAfterPrequalFirstHalf}
                        titleAfterPrequalSecondHalf={props.cmsData?.titleAfterPrequalSecondHalf}
                        r6NGBTitleAfterPrequalFirstHalf={
                          props.cmsData?.r6NGBTitleAfterPrequalFirstHalf
                        }
                        r6NGBTitleAfterPrequalSecondHalf={
                          props.cmsData?.r6NGBTitleAfterPrequalSecondHalf
                        }
                        MBBTitleAfterPrequal={props.cmsData?.MBBTitleAfterPrequal}
                        FTTHinFuture={props.FTTHinFuture}
                        ECCText={props.cmsData?.ECCBannerText}
                        fontColor={props.cmsData?.titleAfterPrequalColor}
                        COEligibilityStatus={props.COEligibilityStatus}
                        maxSpeed={props.maxSpeed}
                        isR6NGB={props.isR6NGB}
                        isMBBJourney={props.isMBBJourney}
                        isNBIJourney={props.isNBIJourney}
                      />
                    )}
                  </Box>
                  <Box>
                    {props.cmsData?.underMaintenance ? (
                      <Box
                        className='prequal-maintenance-container'
                        sx={styles(theme).maintenanceContainer}
                      >
                        <Typography
                          component='p'
                          variant='body1'
                          color={props.cmsData?.fontColor}
                          sx={styles(theme).maintenanceMessage}
                        >
                          {props.cmsData?.maintenanceMessage}
                        </Typography>
                        <Button
                          variant='buttonMedium'
                          sx={{
                            ...styles(theme).checkAvailabilityButton,
                            ...styles(theme).callButton,
                          }}
                          onClick={() => {
                            window.location.href = publicRuntimeConfig.NEXT_PUBLIC_SETCALLBACK;
                          }}
                          aria-label='Setup a call-back'
                        >
                          Setup a call-back
                        </Button>
                      </Box>
                    ) : (
                      <>
                        {showLoader && (
                          <Box
                            sx={{
                              textAlign:
                                sm || (props.cmsData?.PrequalContentAlign === 'Center' && md)
                                  ? 'center'
                                  : '',
                              marginTop: 4,
                            }}
                          >
                            <EirLoader
                              loaderTitle={props.prequalCTALoaderText}
                              padding={{ padding: '0rem 1.5rem' }}
                            />
                          </Box>
                        )}
                        {!showLoader &&
                          // eslint-disable-next-line no-nested-ternary
                          (!props.isPrequaled ? (
                            props.prequalByPhone ? (
                              <BroadbandPrequalPhoneInput
                                prequalHandler={prequalByPhoneHandler}
                                fontColor={props.cmsData?.fontColor}
                                scrollToInput={props.refButton}
                                setPrequalByPhone={props.setPrequalByPhone}
                                setPrequalFailed={setPrequalFailed} // when prequal by eircode fails
                                PrequalContentAlign={props.cmsData?.PrequalContentAlign}
                              />
                            ) : (
                              <BroadbandPrequalInput
                                prequalHandler={prequalHandler}
                                fontColor={props.cmsData?.fontColor}
                                scrollToInput={props.refButton}
                                setPrequalByPhone={props.setPrequalByPhone}
                                PrequalContentAlign={props.cmsData?.PrequalContentAlign}
                              />
                            )
                          ) : (
                            <BroadbandPrequalResult
                              // changeAddress={changeAddress}
                              changePhoneNumber={changePhoneNumber}
                              setIsPrequaled={props.setIsPrequaled}
                              setPrequalStatus={props.setPrequalStatus}
                              fontColor={props.cmsData?.titleAfterPrequalColor}
                              setErrorModalOccurence={props.setErrorModalOccurence}
                              prequalByPhone={props.prequalByPhone}
                              phoneNumber={phoneNumber}
                              setPrequalByPhone={props.setPrequalByPhone}
                              changeOffer={props.changeOffer}
                              COEligibilityStatus={props.COEligibilityStatus}
                              key={props.COEligibilityStatus}
                              setIsMBBJourney={props.setIsMBBJourney}
                              openAccountCheck={openAccountCheck}
                              setIsNBIJourney={props.setIsNBIJourney}
                              setNBIMultiline={setNBIMultiline}
                              setCurrentService={props?.setCurrentService}
                              setIsR6NGB={props.setIsR6NGB}
                              setFTTHinFuture={props.setFTTHinFuture}
                              setShowPrequalTopTag={props.setShowPrequalTopTag}
                            />
                          ))}
                      </>
                    )}
                  </Box>
                  {openAccountCheck.value && !props.isNBIJourney && (
                    <EirCustomerCheckModal
                      setEnableModal={props.setEnableModal}
                      openAccountCheck={openAccountCheck}
                      cmsData={props.imageData}
                      setPrequaledFromBanner={props.setPrequaledFromBanner}
                      existingCustomerModal={existingCustomerModal}
                    />
                  )}
                  {existingCustomerModal.value && !props.isNBIJourney && (
                    <EirExisitingCustomerModal
                      existingCustomerModal={existingCustomerModal}
                      redirectToWebchat={redirectToWebchat}
                    />
                  )}
                </Grid>
                {!props.isPrequaled && props.cmsData?.ShowOfferImage && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={5.5}
                    lg={6}
                    xl={extraLarge ? 4.5 : 5.5}
                    sx={styles(theme).mobileoffers}
                  >
                    <BroadbandPrequalAdvertisement imageData={props.imageData} />
                  </Grid>
                )}
              </>
            )}
          </>
        )}
      </Grid>
      {dataMismatchModal.value && <DataMismatchModal dataMismatchModal={dataMismatchModal} />}
      {dataRetrievalModal.value && errorModalOccurence > errorModalMaxOccurence && (
        <DataRetrievalModal dataRetrievalModal={dataRetrievalModal} handleOk={handleOk} />
      )}
      {prequalNotRespondingModal.value && errorModalOccurence > errorModalMaxOccurence && (
        <PrequalNotRespondingModal
          prequalNotRespondingModal={prequalNotRespondingModal}
          handleOk={handleOk}
        />
      )}
      {openAPIFailureModal.value && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {existingR6Customer && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {errorBBModal.value && (
        <ErrorModal
          errorBBModal={errorBBModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={
            onLoadError
              ? () => {
                  prequalHandler(Graphql);
                }
              : () => {}
          }
        />
      )}
      {errorUANModal.value && <UANErrorModal errorUANModal={errorUANModal} />}
    </Container>
  );
};

export default BroadbandPrequalBanner;
